<script setup>
import {defineProps} from "vue";
const baseUri = process.env.VUE_APP_API_ASSET_URL;
const props =defineProps({ roomPictures: Array })
</script>

<template>
  <div class="uk-width-1-1 uk-margin-medium-top">
    <!-- slider -->
    <div class="impx-room-slider">
      <div class="uk-position-relative" data-uk-slideshow="animation: fade">
        <ul class="uk-slideshow-items">
          <li v-for="(picturePath,index) in props.roomPictures" :key="index">
            <img :src="baseUri+picturePath" alt="picture" data-uk-cover>
            <div class="impx-overlay"></div>
          </li>
        </ul>
        <!-- slider thumb nav -->
        <div class="uk-position-center-left uk-position-medium">
          <ul class="uk-thumbnav uk-thumbnav-vertical">
            <li>
              <router-link :to="'/apartments'">
              <button class="uk-button uk-border-rounded impx-bg-red-csa uk-text-bold impx-text-white">Retour</button>
              </router-link>
            </li>
            <li :data-uk-slideshow-item="index" v-for="(picturePath,index) in props.roomPictures" :key="index">
              <a href="#"><img :src="baseUri+picturePath" width="120" alt="picture"></a></li>
          </ul>
        </div>
        <!-- slider thumb nav end -->
      </div>
    </div>
    <!-- slider end -->
  </div>
</template>

<style scoped>

</style>